/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUser } from './HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUser';
import {
    HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserFromJSON,
    HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserFromJSONTyped,
    HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserToJSON,
    HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserToJSONTyped,
} from './HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUser';

/**
 * 
 * @export
 * @interface HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistUpdatesInner
 */
export interface HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistUpdatesInner {
    /**
     * 
     */
    waitlist_id?: string;
    /**
     * 
     */
    comment?: string;
    /**
     * 
     */
    created_by_user_id?: string;
    /**
     * 
     */
    created_by_user?: HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUser;
    /**
     * 
     */
    created_at?: string;
}

/**
 * Check if a given object implements the HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistUpdatesInner interface.
 */
export function instanceOfHchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistUpdatesInner(value: object): value is HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistUpdatesInner {
    return true;
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistUpdatesInnerFromJSON(json: any): HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistUpdatesInner {
    return HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistUpdatesInnerFromJSONTyped(json, false);
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistUpdatesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistUpdatesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'waitlist_id': json['waitlist_id'] == null ? undefined : json['waitlist_id'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'created_by_user_id': json['created_by_user_id'] == null ? undefined : json['created_by_user_id'],
        'created_by_user': json['created_by_user'] == null ? undefined : HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserFromJSON(json['created_by_user']),
        'created_at': json['created_at'] == null ? undefined : json['created_at'],
    };
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistUpdatesInnerToJSON(json: any): HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistUpdatesInner {
    return HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistUpdatesInnerToJSONTyped(json, false);
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistUpdatesInnerToJSONTyped(value?: HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistUpdatesInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'waitlist_id': value['waitlist_id'],
        'comment': value['comment'],
        'created_by_user_id': value['created_by_user_id'],
        'created_by_user': HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserToJSON(value['created_by_user']),
        'created_at': value['created_at'],
    };
}

